import { VirtualLineupType } from '../../models/dtos/VirtualProviderCatalogDto';

export const VIRTUAL_LINEUP_TYPES: VirtualLineupType[] = ['STARTING_LINEUP', 'SUBSTITUTES', 'COACH'];

export interface VirtualTeamRosterPlan {
    startingLineup: number;
    minimumSubstitutes: number;
    maximumSubstitutes: number;
    coaches: number;
}

export const VIRTUAL_TEAM_ROSTER_PLANS: Record<number, VirtualTeamRosterPlan> = {
    67: { startingLineup: 11, minimumSubstitutes: 5, maximumSubstitutes: 7, coaches: 1 },
    68: { startingLineup: 5, minimumSubstitutes: 5, maximumSubstitutes: 7, coaches: 1 },
    69: { startingLineup: 1, minimumSubstitutes: 1, maximumSubstitutes: 1, coaches: 1 },
};

export const virtualRosterMaximum = (
    plan: VirtualTeamRosterPlan,
    lineupType: VirtualLineupType,
): number => {
    switch (lineupType) {
        case 'STARTING_LINEUP': return plan.startingLineup;
        case 'SUBSTITUTES': return plan.maximumSubstitutes;
        case 'COACH': return plan.coaches;
    }
};

export const virtualLineupLabel = (lineupType: VirtualLineupType): string => {
    switch (lineupType) {
        case 'STARTING_LINEUP': return 'Starting lineup';
        case 'SUBSTITUTES': return 'Substitute';
        case 'COACH': return 'Coach';
    }
};
